import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import BookingSection from './components/BookingSection';
import PaymentSection from './components/PaymentSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-[#050505]">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <BookingSection />
      <PaymentSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </main>
  );
}